<template>
  <div id="noticeDetails">
    <nav-common></nav-common>
    <div class="content-box">
      <div class="title" v-text="noticeItem.title"></div>
      <div class="date">更新日期：<span v-text="noticeItem.created_at"></span></div>
      <div class="content" v-html="noticeItem.content"></div>
      <div class="btnBox">
        <el-button type="primary" @click="goback()">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'NoticeDetails',
  data () {
    return {
      noticeItem: {},
    }
  },
  created() {
    this.getNotice(this.$route.query.type,this.$route.query.id)
  },
  methods: {
    getNotice(type,id) {
      let axurl = '';
      let _this = this
      if(type == 'notice') {
        axurl = _this.$api + '/service/agent/notice/detail/' + id;
      } else if (type == 'tips') {
        axurl = _this.$api + '/wx/card/guide_detail/' + id;
      } else if (type == 'award') {
        axurl = _this.$api + '/service/agent/reward/detail/' + id;
      } else if (type == 'question') {
        axurl = _this.$api + '/wx/question/detail?id=' + id;
      }
      _this.$http({
        method: 'get',
        url: axurl
      }).then((res) => {
        _this.noticeItem = res.data.data;
      });
    },
    goback() {
      this.$router.go(-1);
    }
  },
  components: {
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  #noticeDetails
    .content-box
      position relative
      margin 20px
      padding 60px 40px 20px 40px
      background #f8f8f8
      box-shadow 3px 3px 3px #f5f5f5 inset
    .title
      font-size: 24px
      text-align: center
      padding: 10px 0
    .date
      span
        color: red
    .content
      margin: 15px auto
      border: 1px solid orange
      padding: 15px
    .btnBox
      text-align: center
</style>



// WEBPACK FOOTER //
// src/components/notice/details.vue